import React from 'react';
import { Form, Switch, Input, Select, Row, Col, Button} from 'antd';
import moment from 'moment-jalaali';

import CouponRemoteSelect from './CouponRemoteSelect';
import DatePicker from '../../components/DatePicker';

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
    },
};

class LuckyWheelForm extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            segment_count: props.initialData.segment_count ? props.initialData.segment_count : 6,
            segments: props.initialData.segments != undefined ? props.initialData.segments : [],
            is_pre_publish: props.initialData.is_pre_publish,
        }
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            fieldsValue["segments"] = this.state.segments;
            let atleast = 0;
            if (err) {
                return;
            }
            for(let i in fieldsValue["segments"]) {
                if(fieldsValue["segments"][i].coupon_id > 0) {
                    atleast++;
                }
            }
            if(atleast === 0)
            {
                alert("لطفا حداقل یک قرعه کشی را انتخاب کنید!");
                return;
            }
            let output                 = Object.assign({}, fieldsValue);
            output.publish_date    = output.publish_date ? moment(output.publish_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss') : null;
            output.expiration_date = output.expiration_date ? moment(output.expiration_date).tz('Asia/Tehran').format('YYYY-MM-DD HH:mm:ss'): null;
    

            this.props.submit(output);
        })
    }

    setIsPrePublish = status => {
        this.props.form.setFieldsValue({
            is_pre_publish: status,
        });

        this.setState({is_pre_publish: status});
    }

    segmentCountChange = (value) => {
        this.setState({segment_count: value});
    }

    get isPrePublish() {
        var is = this.props.form.getFieldValue('is_pre_publish');
        return is;
    }

    couponSelected = segment => value => {
        let segments = this.state.segments;
        if (segments[segment] == undefined) {
            segments[segment] = {};
        }
        segments[segment].coupon_id = value;
        console.log('this.state.segments', segments, segment, value);
        this.setState({segments});
    }

    makeSegment(getFieldDecorator, priority, i, segment_value) {
        return (<Form.Item
            {...formItemLayout}
            key={i}
            label={" عنوان قرعه کشی بخش" + (i + 1)}
            style={{direction: "rtl"}}
            colon={false}>
            {getFieldDecorator('s_'+priority,
                {   initialValue: segment_value,
                    rules: [{ required: false, message: '' }]
                }
            )(
                <CouponRemoteSelect selectChanged={this.couponSelected.bind(this)(priority)}/>
            )}
        </Form.Item>
        );
    }

    makeSegments(getFieldDecorator) {
        let segments = [];
        if(typeof this.state.segments[0] != undefined) {
            let count = 0;
            for(let priority in this.state.segments) {
                if(count >= this.state.segment_count){
                    break;
                }
                let segment_value = this.state.segments[priority] != undefined && this.state.segments[priority].id > 0
                ? this.state.segments[priority].title + " " + this.state.segments[priority].content + " " +this.state.segments[priority].brand_name
                : null;
                segments[count] = this.makeSegment(getFieldDecorator, priority, count, segment_value);
                count++;
            }
        }
        for(let priority=segments.length; priority < this.state.segment_count;priority++) {
            segments[priority] = this.makeSegment(getFieldDecorator, priority, priority, null);;
        }
        return segments;
    }

    render(){
        const { getFieldDecorator, getFieldsError } = this.props.form;

        let segments = this.makeSegments(getFieldDecorator);

        return (
            <div style={{direction: 'rtl'}}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="عنوان"
                                colon={false}>
                                {getFieldDecorator("title", {
                                    initialValue: this.props.initialData.title ? this.props.initialData.title : '',
                                    rules: [{
                                        required: true, message:'لطفا عنوان را وارد کنید'
                                    }]
                                })(
                                    <Input/>
                                )}
                            </Form.Item>

                            <Form.Item
                                {...formItemLayout}
                                label="پیش نویس است؟"
                                colon={false}>
                                    {getFieldDecorator('is_pre_publish', {
                                    valuePropName: 'checked',
                                        initialValue: this.props.initialData.publish_date ? false : (this.props.initialData.id && !this.props.initialData.publish_date  ? true : false)
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsPrePublish}/>
                                )}
                            </Form.Item>

                        {
                            !this.isPrePublish && (<React.Fragment>
                            <Form.Item
                                {...formItemLayout}
                                label="تاریخ انتشار"
                                style={{direction: 'ltr'}}
                                colon={false}>
                                {getFieldDecorator('publish_date',
                                {initialValue: moment(this.props.initialData.publish_date  ? this.props.initialData.publish_date : Date.now()),
                                    rules: [{
                                        type: 'object',
                                        required: true,
                                        message: 'انتخاب تاریخ انتشار ضروری است'
                                    }]
                                }
                            )(
                                <DatePicker isGregorian={false} inputJalaaliFormat="jYYYY-jMM-jDD HH:mm" time_picker_props={{showAMPM: false}}/>
                            )}
                            </Form.Item>
                        </React.Fragment>)
                        }

                            <Form.Item
                                {...formItemLayout}
                                label="تاریخ انقضا"
                                style={{direction: 'ltr'}}
                                colon={false}>
                                {getFieldDecorator('expiration_date',
                                    {initialValue: this.props.initialData.expiration_date ? moment(this.props.initialData.expiration_date) : null,
                                        rules: [{ type: 'object', required: false, message: '' }]}
                                )(
                                    <DatePicker isGregorian={false} inputJalaaliFormat="jYYYY-jMM-jDD HH:mm" time_picker_props={{showAMPM: false}}/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={5} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="محدودیت امتیاز"
                                colon={false}>
                                {getFieldDecorator("score_limitation", {
                                    initialValue: this.props.initialData.score_limitation ? this.props.initialData.score_limitation : 0,
                                    rules: [{
                                        required: true, message:'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]
                                
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={9} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="حداکثر تعداد شرکت بر اساس محدودیت تعداد روز"
                                colon={false}>
                                {getFieldDecorator("attends_limitation", {
                                    initialValue: this.props.initialData.attends_limitation ? this.props.initialData.attends_limitation : 0,
                                    rules: [{
                                        required: true, message:'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]
                                
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={5} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="محدودیت تعداد روز"
                                colon={false}>
                                {getFieldDecorator("days_limitation", {
                                    initialValue: this.props.initialData.days_limitation ? this.props.initialData.days_limitation : 0,
                                    rules: [{
                                        required: true, message:'لطفا عدد وارد کنید',
                                        pattern: new RegExp(
                                            /^[0-9]+$/i
                                        )
                                    }]
                                            
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={1}>
                            <Form.Item
                                {...formItemLayout}
                                label="تعداد آیتم ها"
                                colon={false}>
                                    {getFieldDecorator('segment_count', {
                                        initialValue: this.props.initialData.segment_count ? this.props.initialData.segment_count : 6,
                                        rules: [
                                        { required: true, message: 'تعداد آیتم ها را انتخاب نمایید' },
                                        ],
                                    })(
                                        <Select defaultValue="6" style={{ width: 120 }} onChange={this.segmentCountChange}>
                                            <Select.Option value="6">6</Select.Option>
                                            <Select.Option value="8">8</Select.Option>
                                            <Select.Option value="10">10</Select.Option>
                                            <Select.Option value="12">12</Select.Option>
                                        </Select>
                                    )}
                            </Form.Item>
                            {segments}

                            <Form.Item>
                                <div className="btn-container">
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        disabled={hasErrors(getFieldsError()) || this.props.submitted}
                                        >
                                        {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                                    </Button>
                                </div>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
export default Form.create({ name: 'horizontal_login' })(LuckyWheelForm);



// WEBPACK FOOTER //
// ./src/containers/LuckyWheels/form.js